import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import DataSource from "devextreme/data/data_source";
import { confirm } from 'devextreme/ui/dialog';
import ArrayStore from 'devextreme/data/array_store';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { SupplierConnectionService } from "./supplier-connection.service";
import { DxDataGridComponent } from "devextreme-angular";
import { Router } from "@angular/router";
import { SharedService } from "src/app/services/SharedService";
import { Constants } from "src/app/common/constants";
import { NotificationTypes } from "src/app/common/component/notification/notification.component";
import { ProductUOMConversionsService } from "src/app/common/service/productuomconversions.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: 'supplier-connection',
    templateUrl: './supplier-connection.component.html',
    styleUrls: ['./supplier-connection.component.scss']
})

export class SupplierConnectionComponent implements AfterViewInit {
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    supplyConnections: any;
    supplyConnectionsDataSource: DataSource;
    @Input() pipelineId: number;
    @Input() sites: any;
    @Input() uoms: any;
    @Input() materialId: any;
    @Input() pipelineCode: any;
    @Input() materialName: any;
    @Output() setLoadPanelVisibility: EventEmitter<boolean> = new EventEmitter();

    constructor(private router: Router, private supplierConnectionService: SupplierConnectionService, private notificationService: NotificationService, private sharedSvc: SharedService,
        private productUOMConversionsService: ProductUOMConversionsService) {
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.editSupplierSite = this.editSupplierSite.bind(this);
        this.setUOMValue = this.setUOMValue.bind(this);
    }

    ngAfterViewInit(): void {
        this.getSupplyConnections();
    }

    async setUOMValue(rowData: any, value: any, currentRowData: any) {

        if (this.materialName == "") {
            this.materialName = this.uoms.filter(x => x.productId == this.materialId)[0].productLongDesc;
        }

        rowData.uom = value;
        if ([Constants.material_Syngas, Constants.material_Steam, Constants.material_Other].indexOf(this.materialId) > -1) {
            this.notificationService.alert(NotificationTypes.Warning, "Please calculate the Quantity manually and update the same", null);
            return rowData;
        } else {
            if (currentRowData.uom && currentRowData.quantity) {
                var conversionDataPromise = this.productUOMConversionsService.getProductUOMConversion(this.materialName, 'Gas', currentRowData.uom, value)
                var conversionData = await lastValueFrom(conversionDataPromise);
                rowData.quantity = (currentRowData.quantity * eval(conversionData.conversionFactorValue)).toFixed(4);
                return rowData;
            }
        }
    }

    getSupplyConnections() {
        this.setLoadPanelVisibility.emit(true);
        this.supplierConnectionService.getSupplyConnections(this.pipelineId).subscribe({
            next: supplyDemandConnections => {
                this.supplyConnectionsDataSource = new DataSource({
                    store: new ArrayStore({
                        data: supplyDemandConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while fetching Supply Demand Connections", error);
            }
        });
    }

    addSupplierConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.supplyDemandConnectionId = 0;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);

        this.supplierConnectionService.addsupplierconnection(event.data).subscribe({
            next: customerConnections => {
                this.supplyConnectionsDataSource = new DataSource({
                    store: new ArrayStore({
                        data: customerConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Supplier connection created successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while fetching Supply Demand Connections", error);
            }
        });
    }

    updateSupplierConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);

        this.supplierConnectionService.updatesupplierconnection(event.data).subscribe({
            next: customerConnections => {
                this.supplyConnectionsDataSource = new DataSource({
                    store: new ArrayStore({
                        data: customerConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Supplier connection updated successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while fetching Supply Demand Connections", error);
            }
        });

    }

    deleteSupplierConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);

        this.supplierConnectionService.deleteSupplierConnection(event.data.supplyDemandConnectionId).subscribe({
            next: customerConnections => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Supplier connection deleted successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while deleting Supplier connection", error);
            }
        });
    }

    onSupplierGridToolbarPreparing(event) {
        let toolbarItems = event.toolbarOptions.items;
        let addRowButton = toolbarItems.find(x => x.name === "addRowButton");
        addRowButton.options.text = "Add Supplier Connection";
        addRowButton.options.type = 'default';
        addRowButton.options.icon = '';
        addRowButton.showText = "always";
    }

    onSaveClick(e) {
        this.dataGrid.instance.saveEditData();
        this.dataGrid.instance.columnOption('uom', 'caption', 'Uom');
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.dataGrid.instance.cancelEditData();
                that.dataGrid.instance.columnOption('uom', 'caption', 'Uom');
            }
        });
    }

    editSupplierSite(e) {

        this.sharedSvc.previousRouteToEditSite = "/pipelines/" + this.pipelineId + '/' + this.materialId;
        var siteId = e.row.data.supplierSiteId;

        this.router.navigate(["/editsite/" + siteId]);
        return false;
    }

}